import Home from './routes/home.svelte';

import Studio from './routes/studio.svelte';

import Illustrations from './routes/illustrations.svelte';

import Contact from './routes/contact.svelte';

export default {
    '/': Home,
    '/studio': Studio,
    '/illustrations': Illustrations,
    '/contact': Contact,
};